
import SBM from './sbm.js';


export default SBM.user;

